export default "__VITE_ASSET__NBF9W6cD__"